import { render, staticRenderFns } from "./add-account.vue?vue&type=template&id=380f17bd&scoped=true&"
import script from "./add-account.vue?vue&type=script&lang=js&"
export * from "./add-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f17bd",
  null
  
)

export default component.exports